import { FaClock, FaMapMarkerAlt, FaUserTie, FaDollarSign, FaTags, FaBriefcase, FaCalendarAlt, FaPhone, FaUsers, FaEnvelope, FaMicrophone, FaFileAlt, FaVideo, FaClipboardCheck, FaAward, FaGraduationCap, FaBrain, FaLaptopCode, FaCode, FaShieldAlt, FaChartBar, FaCloud, FaDatabase, FaPaintBrush, FaTasks } from 'react-icons/fa';
import { FaCloudArrowUp, FaShield } from 'react-icons/fa6';



// Function to render the appropriate icon based on the service name
export const renderIcon = (iconName) => {

  // Convert the service name to lowercase
  const lowercaseServiceName = iconName.toLowerCase();

  // Check the lowercase service name and return the corresponding icon component
  switch (lowercaseServiceName) {

    /*----- Service Icons -----*/
    case 'ai-powered solution':
      return <FaBrain />; // Clipboard Check icon representing event registration

    case 'it consulting':
      return <FaLaptopCode />; // Calendar Alt icon representing event schedule/timetable

    case 'cloud integration':
      return <FaCloudArrowUp />; // Handshake icon representing networking opportunities

    case 'code development':
      return <FaCode />; // Microphone icon representing speakers

    case 'cyber protection':
      return <FaShieldAlt />; // Video icon representing virtual participation

    case 'big data analytics':
      return <FaChartBar />; // File Alt icon representing event materials/resources


    /*----- Position Icons -----*/
    case 'ai software developer':
      return <FaCode />; // Clipboard Check icon representing event registration

    case 'cloud solutions engineer':
      return <FaCloud />; // Calendar Alt icon representing event schedule/timetable

    case 'data scientist':
      return <FaDatabase />; // Handshake icon representing networking opportunities

    case 'ux/ui designer':
      return <FaPaintBrush />; // Microphone icon representing speakers

    case 'ai project manager':
      return <FaTasks />; // Video icon representing virtual participation

    case 'ai security analyst':
      return <FaShield />; // File Alt icon representing event materials/resources


    /*----- Support Button Icons -----*/
    case 'web design':
      return <FaClipboardCheck />; // Clipboard Check icon representing event registration

    case 'app development':
      return <FaCalendarAlt />; // Calendar Alt icon representing event schedule/timetable

    case 'cloud solutions':
      return <FaMicrophone />; // Microphone icon representing speakers

    case 'digital marketing':
      return <FaVideo />; // Video icon representing virtual participation

    case 'cyber security':
      return <FaFileAlt />; // File Alt icon representing event materials/resources

    case 'start up accelerator':
      return <FaVideo />; // Video icon representing virtual participation

    case 'it support':
      return <FaFileAlt />; // File Alt icon representing event materials/resources

    /*----- Page Sidebar -----*/
    case 'date':
    case 'days':
    case 'deadline':
      return <FaCalendarAlt />; // Calendar icon representing a date or deadline
  
    case 'time':
    case 'timing':
    case 'hours':
      return <FaClock />; // Clock icon representing time-related info

    case 'duration':
      return <FaClock />; // Clock icon representing time-related info

    case 'targetaudience':
    case 'position':
    case 'students':
      return <FaUsers />; // Users icon representing a group of people

    case 'category':
      return <FaTags />; // Tags icon representing category or skill level

    case 'skilllevel':
      return <FaGraduationCap />; // Tags icon representing category or skill level

    case 'location':
      return <FaMapMarkerAlt />; // Map Marker icon representing a location

    case 'investment':
    case 'salary':
    case 'fee':
      return <FaDollarSign />; // Dollar sign icon representing cost or payment

    case 'experience':
      return <FaBriefcase />; // Award icon representing experience or achievement

    case 'projectlead':
    case 'instructor':
    case 'organizer':
      return <FaUserTie />; // User Tie icon representing an organizer or instructor

    case 'certificate':
      return <FaAward />; // Award icon representing certification

    case 'number':
      return <FaPhone />; // Phone icon representing contact number

    case 'email':
      return <FaEnvelope />; // Envelope icon representing an email address

    default:
      return null; // Return null if no matching icon is found
  }

};